/**
 * API helper that switches between dynamic API endpoints (dev) and static JSON files (production).
 * 
 * In development: fetches from /api/jobs, /api/jobs/:id
 * In production (static): fetches from ./data/jobs.json, ./data/jobs/:id.json (relative paths for GitHub Pages)
 */

/**
 * Check if we're in production mode.
 * Bun's build defines process.env.NODE_ENV at build time.
 */
const isProduction = process.env.NODE_ENV === 'production';

/**
 * Get the base URL for static data files.
 * Uses relative paths to work with GitHub Pages subdirectory deployment.
 */
function getBaseUrl(): string {
  if (!isProduction) {
    return '';
  }
  // In production, use relative path from current page
  // This works because index.html and data/ are in the same directory
  return '.';
}

/**
 * Fetch the list of all jobs.
 */
export async function fetchJobs(): Promise<any[]> {
  const base = getBaseUrl();
  const url = isProduction ? `${base}/data/jobs.json` : '/api/jobs';
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch jobs: ${res.status}`);
  }
  return res.json();
}

/**
 * Fetch details for a specific job.
 */
export async function fetchJobDetail(jobId: string): Promise<any> {
  const base = getBaseUrl();
  const url = isProduction ? `${base}/data/jobs/${jobId}.json` : `/api/jobs/${jobId}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch job ${jobId}: ${res.status}`);
  }
  return res.json();
}
